(function () {
    window.feHPEB2C.log('FE: 4037: start');
    if (typeof feProjectId === 'undefined') {
        var feProjectId = 'FE:4037';
    }

    const txt = {
        ExploreOffersFromOurPartners: 'Explore offers from our valued channel partners',
        SeeOffers: 'See offers'

    }
    const SelectorsDictionary = {
        FacetSection: 'section.hpe-filter-list',
        WrapFacetSection: 'div.facet' //+ inputValueFilter
    }
    let FE_LOADER = (window.feReusable.findGetParameter('FE_LOADER') || '')

    function renderBox() {
        let html = `
        <div class="fe-4037-lbox">
        <hr />
        <div class="fe-4037-eefovcp">${txt.ExploreOffersFromOurPartners}</div>
        <a class="fe-4037-seeoffers" href="#"  
          onclick="return showShopnowDialog(this, 'P9R83A', false, 'HPE G2 Metered 3Ph 17.3kVA/60309 60A 4‑wire 48A/208V Outlets (36) C13 (12) C19/Vertical NA/JP PDU')&&false;">
${txt.SeeOffers} </a>
</div>   `;
        window.feHPEB2C.log('FE: 4037: renderBox', html);
        return html;
    }

    function init() {
        jQuery(SelectorsDictionary.FacetSection).append(renderBox());
    }


    window.feUtils.waitForConditions({
        conditions: [
            SelectorsDictionary.FacetSection,
            window.FEi18n?.isReady],
        activity: feProjectId,
        callback: init,
    })
})();
